"use client";

import { useState } from "react";
import OverlayCard from "../shared/card/overlay-card";
import sticker7 from "../../../public/sticker7.png";
import sticker8 from "../../../public/sticker8.png";
import SectionTitle from "../shared/SectionTitle";

const events = [
  {
    year: "1960",
    title: "Il Noviziato",
    description:
      "Le prime testimonianze del lavoro svolto a Casa Betania risalgono al 1960, quando inizia nella Casa, non nuova e da ristrutturare, l'attività di noviziato. Le novizie furono le prime ad abitare i locali di Casa Betania e vi rimasero fino all'ottobre 1965.",
  },
  {
    year: "1966",
    title: "Inizio Del Convitto",
    description:
      "Dopo alcune modifiche e qualche lavoro di riadattamento dei locali, nel 1966 cominciò a funzionare il convitto per le bambine provenienti da famiglie disagiate o orfane.",
  },
  {
    year: "1982",
    title: "Nasce La Scuola Materna",
    description:
      "Negli anni '80 l'internato diminuì progressivamente, mentre crebbe la richiesta di una scuola materna e servizi per l'infanzia. Nel 1982 nacquero due sezioni di scuola materna approvate ufficialmente, seguite da un semiconvitto con mensa, dopo-scuola e attività educative per i bambini delle elementari.",
  },
  {
    year: "2002",
    title: "La Scuola Diventa Paritaria",
    description:
      "Con decreto del 22 febbraio n. 3487 il Ministero della Pubblica Istruzione ha riconosciuto alla scuola dell'Infanzia lo status di Scuola Paritaria.",
  },
  {
    year: "2003/2004",
    title: "Nuova Struttura",
    description:
      "Nell'anno 2003/2004 la Scuola dell'Infanzia fa il suo primo ingresso nella struttura costruita secondo le norme vigenti.",
    highlight: true,
  },
  {
    year: "2023",
    title: "Verso lo 0-6 anni",
    description:
      "Con Determinazione Dirigenziale n. 188 del 16/02/2023 è stata istituita la Sezione Primavera, rivolta ai bambini dai 24 ai 36 mesi. L’iniziativa, voluta da Sr. Luisa De Capite e realizzata con la Coordinatrice Mariangela Melica, offre un ambiente educativo qualificato e accogliente. La struttura fa parte del progetto educativo integrato 0–6 anni, garantendo continuità pedagogica e attenzione alla crescita dei bambini. Le famiglie possono usufruire di agevolazioni come il Bonus Nido.",
  },
];

export default function StyledTimeline() {
  const [selectedYear, setSelectedYear] = useState<string>("1960");

  // 👉 qui usiamo OverlayCard: quando valorizzato, apre la modale
  const [overlayItem, setOverlayItem] = useState<{
    title?: string;
    fullDescription?: string;
    carouselImages?: string[];
  } | null>(null);

  // immagini “Gli Spazi”
  const spacesImages = [
    "/struttura-timeline/struttura1.webp",
    "/struttura-timeline/struttura2.webp",
    "/struttura-timeline/struttura3.webp",
    "/struttura-timeline/struttura4.webp",
    "/struttura-timeline/struttura5.webp",
    "/struttura-timeline/struttura6.webp",
    "/struttura-timeline/struttura7.webp",
    "/struttura-timeline/struttura8.webp",
    "/struttura-timeline/struttura9.webp",
    "/struttura-timeline/struttura11.webp",
  ];

  return (
    <section className="py-24 px-8 md:px-12">
      <SectionTitle
        title1="La Nostra"
        title2=" Storia"
        leftIcon={sticker7}
        rightIcon={sticker8}
        iconSizeLeft={150}
        iconSizeRight={150}
        hideIconOnMobile="right"
      />

      <div className="flex flex-col lg:flex-row divide-y lg:divide-y-0 lg:divide-x divide-(--card-foreground)">
        {events.map((event, index) => {
          const isActive = event.year === selectedYear;
          return (
            <div
              key={index}
              onClick={() => setSelectedYear(event.year)}
              className={`flex-1 px-6 py-8 max-h-[600px] lg:min-h-[250px] cursor-pointer transition duration-300 ${
                isActive
                  ? "bg-(--card-foreground) text-(--background)"
                  : "bg-(--card)"
              }`}
            >
              <div
                className={`mb-2 text-sm font-semibold ${
                  isActive ? "opacity-90" : "text-gray-500"
                }`}
              >
                {event.year}
              </div>

              <h3
                className={`uppercase font-bold tracking-wide mb-4 ${
                  isActive ? "text-white" : "text-(--card-foreground)"
                }`}
              >
                {event.title}
              </h3>

              <p
                className={`text-sm leading-relaxed ${
                  isActive ? "text-white/90" : "text-gray-700"
                }`}
              >
                {event.description}
              </p>

              {event.year === "2003/2004" && (
                <div className="mt-6">
                  <button
                    className={`cursor-pointer rounded-none px-4 py-2 text-md transition ${
                      isActive
                        ? "bg-(--background) text-(--btn-bg)"
                        : "bg-(--btn-bg) text-(--btn-foreground) hover:bg-(--btn-hover)"
                    }`}
                    onClick={() =>
                      setOverlayItem({
                        title: "Gli Spazi",
                        carouselImages: spacesImages,
                      })
                    }
                  >
                    Dai uno sguardo!
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <OverlayCard
        selectedItem={overlayItem}
        onClose={() => setOverlayItem(null)}
        maxWidthClass="max-w-[1000px]"
        maxHeightClass="max-h-[90vh]"
      />

      <div className="mt-10 flex justify-center gap-4 text-sm text-gray-500 flex-wrap">
        {events.map((event, i) => (
          <button
            key={i}
            onClick={() => setSelectedYear(event.year)}
            className={`cursor-pointer px-2 py-1 transition duration-200 ${
              event.year === selectedYear
                ? "border-b-2 border-[#10b0ff] font-semibold text-black"
                : ""
            }`}
          >
            {event.year}
          </button>
        ))}
      </div>
    </section>
  );
}